<div class="relative">
  <label
    [for]="inputId"
    class="mb-3 block font-medium tracking-wide"
    [ngClass]="{
      'text-gray-700': labelMode === 'PRIMARY',
      'text-purple-100': labelMode === 'SECONDARY',
      'text-black-700 font-semibold leading-none !text-base !whitespace-nowrap':
        labelMode === 'E-COMMERCE',
      'text-purple-100 font-semibold leading-none !text-sm !whitespace-nowrap':
        labelMode === 'E-COMMERCE_SECONDARY',
      'text-sm ': labelSize === 'MEDIUM',
      'text-xs': labelSize === 'SMALL',
      '!mb-0': !label,
    }"
    [ngStyle]="{ 'margin-left': labelMargin + 'px' }"
    [attr.aria-label]="!label ? ariaLabel() : null"
    >{{ label }}
  </label>

  <div
    class="relative flex w-full gap-2"
    [ngClass]="{
      '!pointer-events-none text-gray-600': disabledMode,
      'flex-col gap-0': additionalTextStyle === 'secondary',
    }"
    >
    @if (iconName) {
      <div
      [ngClass]="{
        'flex h-8 w-9 min-w-[36px] items-center justify-center rounded border border-gray-300 bg-gray-100':
          iconMode === 'OUTSIDE',
        'absolute left-6 top-1/2 translate-y-[-50%] cursor-pointer':
          iconMode === 'INSIDE',

        '!left-3': iconMode === 'INSIDE' && padding === 'small',
      }"
        >
        <neopos-icon [name]="iconName"></neopos-icon>
      </div>
    }

    <ng-content select="[additionalSelect]" />

    <input
      #input
      [id]="inputId"
      [disabled]="disabled"
      [type]="inputType"
      [placeholder]="placeholder"
      [maxlength]="maxlength"
      [inputMask]="inputMask ? inputMaskValue : null"
      [(ngModel)]="value"
      [attr.aria-invalid]="showError && error ? 'true' : null"
      [attr.aria-describedby]="getDescribedBy()"
      (blur)="isNumber && onConvertToNumber(); onBlur()"
      (focus)="focus.emit()"
      (keydown)="keydown.emit($event)"
      [ngClass]="{
        error: error,
        'text-gray-600': disabled,
        '!border-red-500': (error || mutationError) && !errorColor(),
        'pl-14': iconName && iconMode === 'INSIDE' && padding === 'normal',
        'pl-12': iconName && iconMode === 'INSIDE' && padding === 'small',
        'pr-12': additionalText,
        'px-4 py-[6.5px] text-sm leading-none': padding === 'small',
        '!py-[7px]': padding === 'medium',
        'text-center !text-[28px] tracking-wider': mode === 'PIN',
        '!bg-gray-950': disabledMode,
        'focus:outline focus:outline-2 focus:outline-offset-2 outline-gray-700':
          isFocusOutline(),
        'focus:outline-none': !isFocusOutline(),
        'text-xs': fontSize === 'SMALL',
        'border': showBorder(),
        'rounded': showRadius(),
        'text-center': isTextCenter(),
      }"
      class="max-h-[60px] w-full rounded border-solid border-gray-300 bg-white p-5 text-base leading-none text-gray-700 placeholder-gray-500 disabled:!bg-gray-950"
      [style.width.px]="width"
      [style.height.px]="height()"
      [style.padding]="themePadding"
      [style.borderColor]="error ? errorColor() : null"
      [attr.autocomplete]="autocomplete() || null"
      />

    @if (additionalText) {
      <span
        class="absolute top-1/2 right-2 -translate-y-1/2 font-normal text-gray-700 text-sm"
      [ngClass]="{
          '!text-xs leading-none !static !translate-y-0':
            additionalTextStyle === 'secondary',
        }"
        >{{ additionalText }}</span
        >
      }

      @if (type === 'password' && mode === 'REGULAR' && !disabled) {
        @if (!isPasswordVisible()) {
          <neopos-icon
        (click)="
          !disableShowPassword && isPasswordVisible.set(!isPasswordVisible())
        "
            name="eye"
            class="absolute right-4 top-5 translate-y-[-50%] cursor-pointer text-2xl"
          ></neopos-icon>
        }
        @if (isPasswordVisible()) {
          <neopos-icon
        (click)="
          !disableShowPassword && isPasswordVisible.set(!isPasswordVisible())
        "
            name="eye-closed"
            class="absolute right-4 top-5 translate-y-[-50%] cursor-pointer text-2xl"
          ></neopos-icon>
        }
      }
    </div>

    <div
      [id]="inputId + '-hint'"
      [class.sr-only]="!bottomText"
      class="py-2 text-sm text-gray-700"
      >
      {{ bottomText || '' }}
    </div>

    <div
      [id]="inputId + '-error'"
      [class.sr-only]="!(showError && error)"
      class="text-xs text-red-500"
      [style.color]="errorColor()"
    [ngClass]="{
      'absolute -bottom-5 left-0': errorAbsolute,
      static: !errorAbsolute,
      'py-1': showError && error,
    }"
      >
      {{ (showError && error ? error : '') | translate }}
    </div>
  </div>
